import { render, staticRenderFns } from "./ShareLink.vue?vue&type=template&id=9828bede&scoped=true&"
import script from "./ShareLink.vue?vue&type=script&lang=js&"
export * from "./ShareLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9828bede",
  null
  
)

export default component.exports